import axios from '../axios'

/**
 * 查询
 */
export const findPage = data => {
  return axios({
    url: '/refund/list',
    method: 'post',
    data
  })
}

/**
 * 审核
 */
export const agree = data => {
  return axios({
    url: '/refund/approve',
    method: 'post',
    data
  })
}
/**
 * 退款
 * @param data
 */
export const reject = data => {
  return axios({
    url: '/refund/refund',
    method: 'post',
    data
  })
}




// WEBPACK FOOTER //
// ./src/http/modules/refund.js